import { useContext, useEffect, useState } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import './App.css';
import LoginPage from './pages/loginPage';
import Header from './components/Header';
import GuestData from './pages/GuestData';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HotelList from './pages/HotelList';
import RoomMaster from './pages/RoomMaster';
import Roomstatus from './pages/Roomstatus';
import ReceptionistList from './pages/ReceptionistList';
import ResetPassword from './components/ResetPassword';
import Superadmindashboard from './pages/Superadmindashboard';
import { getCredit, setLogoutFunction } from './utils/helperFunctions';
import { Navigate } from 'react-router-dom';
import UploadCsv from './pages/UploadCsv';
import IncompleteCheckinReport from './pages/IncompleteCheckinReport';
import RoomcleaningData from './pages/RoomcleaningData';
import AddCredit from './pages/AddCredit';
import { Mycontext } from './context/context';


function App() {
  const [token, setToken] = useState(localStorage.getItem("authToken"));
  const [isResetPassword,setIsResetPassword] = useState(localStorage.getItem("isResetPassword")==='true')
  const role = localStorage.getItem("role");
  const { updateCredit,creditToupdate,setCreditToupdate} = useContext(Mycontext); 

  useEffect(() => {
    setLogoutFunction(handleLogout);
  }, []);

  useEffect(() => {
    const fetchInitialCredit = async () => {
      if (token && !isResetPassword && creditToupdate) {
        try {
          const response = await getCredit();
          if (response.status) {
            updateCredit({
              creditBalance: response.data.creditBalance,
              hotelName: response.data.hotelName
            });
            setCreditToupdate(false)
          }
        } catch (error) {
          console.error('Failed to fetch initial credit:', error);
        }
      }
    };
    
    fetchInitialCredit();
  }, [token, isResetPassword, creditToupdate]);


  const handleLogin = (role, token, refreshToken, name,isResetPassword) => {
    localStorage.setItem("role", role);
    localStorage.setItem("authToken", token);
    localStorage.setItem("refreshToken", refreshToken);                                
    localStorage.setItem("name", name);
    localStorage.setItem("isResetPassword", isResetPassword);
    setToken(token);
    setIsResetPassword(isResetPassword)
    setCreditToupdate(role !== "superAdmin")
  };

  const handleLogout = () => {
    localStorage.clear();
    setToken(null);
    setIsResetPassword(null)
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <BrowserRouter>
      <Routes>
        {!token ? (
          <>
            <Route path="/" element={<LoginPage onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : isResetPassword ? (
          // If user needs to reset password, redirect to reset password page
          <Route path="*" element={
            <ResetPassword 
                setIsResetPassword={setIsResetPassword}
            />
          } />
        ) : (
          // Normal authenticated routes
          <>
            <Route
              path="*"
              element={
                <>
                  <div className="w-full h-screen flex flex-col bg-gray-50">
                    <Header handleLogout={handleLogout} />
                    <div className="w-full h-[calc(100% - 60px)] overflow-y-auto">
                      <Routes>
                        {role === "superAdmin" && (
                          <>
                            <Route path="/" element={<Superadmindashboard />} />
                            <Route path="/hotel" element={<HotelList onLogin={handleLogin}/>} />
                            <Route path="/upload-csv/:hotelId" element={<UploadCsv />} />
                            <Route path="/add-credit/:hotelId" element={<AddCredit />} />
                          </>
                        )}
                        {(role === "manager" || role === "view only" ) && (
                          <>
                            <Route path="/" element={<Roomstatus role={role}/>} />
                            <Route path="/room" element={<RoomMaster role={role}/>} />
                            <Route path="/receptionist" element={<ReceptionistList role={role}/>} />
                            <Route path="/guestdetail" element={<GuestData role={role} />} />
                            <Route path="/roomcleaning" element={<RoomcleaningData />} />
                            <Route path="/report/incomplete-checkin" element={<IncompleteCheckinReport role={role}/>} />
                            
                          </>
                        )}
                        {role === "receptionist" && (
                          <>
                            <Route path="/" element={<Roomstatus role={role} />} />
                            <Route path="/guestdetail" element={<GuestData role={role} />} />
                            <Route path="/report/incomplete-checkin" element={<IncompleteCheckinReport/>} />
                          </>
                        )}
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </div>
                  </div>
                </>
              }
            />
          </>
        )}
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
